
import { apiRequest, SUPABASE_URL } from "./apiUtils";
import { config } from "@/config";

// Define a constant for the application's sender email address
export const DEFAULT_SENDER_EMAIL = config.DEFAULT_SENDER_EMAIL;

export interface EmailLogEntry {
  id?: string;
  customer_id: number;
  to_email: string;
  from_email: string;
  subject: string;
  content: string;
  sent_at?: Date | string;
  delivered_at?: Date | string | null;
  opened_at?: Date | string | null;
  clicked_at?: Date | string | null;
  bounced_at?: Date | string | null;
  spam_reported_at?: Date | string | null;
  entity_name?: string;
  entity_id?: number;
  message_id?: string;
  attachments?: Array<{
    filename: string;
    content: string;
    type?: string;
  }>;
}

export const emailApi = {
  getCustomerEmails: async (customerId: number) => 
    apiRequest<EmailLogEntry[]>(`${SUPABASE_URL}/customer-emails?customerId=${customerId}`),
    
  getEntityEmails: async (entityName: string, entityId: number) => 
    apiRequest<EmailLogEntry[]>(`${SUPABASE_URL}/customer-emails?entityName=${entityName}&entityId=${entityId}`),
    
  // This function both sends the email through Resend and logs it in the database
  sendAndLogEmail: async (emailData: EmailLogEntry) => 
    apiRequest<EmailLogEntry>(`${SUPABASE_URL}/customer-emails`, {
      method: 'POST',
      body: {
        ...emailData,
        from_email: emailData.from_email || DEFAULT_SENDER_EMAIL
      }
    }),
    
  // This function just logs an email entry without sending
  logEmail: async (emailData: EmailLogEntry) => 
    apiRequest<EmailLogEntry>(`${SUPABASE_URL}/customer-emails`, {
      method: 'POST',
      body: {
        ...emailData,
        from_email: emailData.from_email || DEFAULT_SENDER_EMAIL
      }
    }),
    
  updateEmailStatus: async (emailId: string, statusUpdate: {
    delivered_at?: Date | string;
    opened_at?: Date | string;
    clicked_at?: Date | string;
    bounced_at?: Date | string;
    spam_reported_at?: Date | string;
  }) => 
    apiRequest<EmailLogEntry>(`${SUPABASE_URL}/customer-emails/${emailId}/status`, {
      method: 'PATCH',
      body: statusUpdate
    })
};
